iScreenWizard.controller('InstantAccessController', function ($scope, $state, $stateParams, $mdDialog, Dictionary, Gebruikersbericht, userService, Ajax) {

    userService.token = $stateParams.jwt;
    userService.SaveState();

    params = {
        _method: "authinfo",
    };
    Ajax.post('authenticate', params).then(function (response) {
        if (response.data._errors !== null || response.data._errors.length < 1) {
            userService.password = '';

            //save user data
            userService.model = response.data;
            userService.model.loginExpires = response.data.jwt_expires_at;
            userService.model.wizardNiveau = response.data.wizard_niveau;
            userService.model.wizardModules = response.data.wizard_modules;
            userService.model.isSsoUser = response.data.is_sso_user;
            userService.SaveState();

            Gebruikersbericht.countUnread().then(function (nrUnreadUserMessages) {
                var go = 'home';
                //go to home screen and check for new messages
                $state.go(go).then(function () {
                    if (nrUnreadUserMessages > 1) {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                .textContent(Dictionary.translate('app.youve_got_:i_new_messages', true, { i: nrUnreadUserMessages }))
                                .ariaLabel(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                .ok(Dictionary.translate('app.okay', true))
                        );
                    } else if (nrUnreadUserMessages == 1) {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                .textContent(Dictionary.translate('app.youve_got_one_new_message', true, { i: nrUnreadUserMessages }))
                                .ariaLabel(Dictionary.translate('app.welcome_:name', true, { 'name': userService.model.voornaam }))
                                .ok(Dictionary.translate('app.okay', true))
                        );
                    }
                });
            });

        }
    });
});
